module.exports = {"450702001":"向阳街道","450702002":"水东街道","450702003":"文峰街道","450702004":"南珠街道","450702005":"尖山街道","450702100":"沙埠镇","450702101":"康熙岭镇","450702102":"黄屋屯镇","450702104":"大番坡镇","450702105":"龙门港镇","450702107":"久隆镇","450702108":"东场镇","450702109":"那丽镇","450702110":"那彭镇","450702111":"那思镇","450702112":"犀牛脚镇","450702400":"丽光华侨农场","450702401":"钦州港经济技术开发区","450702402":"三娘湾旅游管理区","450702403":"广西钦州保税港区","450702404":"中马钦州产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450702.json
// module id = 2252
// module chunks = 0